// Per-company noun for "the person on this record" (0232, Grant
// 2026-08-03) — a display label derived from the service family, never
// stored. Dependency-free on purpose: imported by BOTH the web bundle
// (household cards, record page) and the server data layer, so it must
// not pull DB code into the browser.

export function personRoleNoun(
  serviceFamily: string,
  serviceType?: string | null,
): string {
  switch (serviceFamily) {
    case "loan":
      return "Borrower";
    case "policy":
    case "case":
      // Insurance policies and Planning cases (Medicare, health, life,
      // disability …) all read "Insured"; the estate plan is the one
      // case type with no insurance shape.
      return serviceType === "estate_plan" ? "Client" : "Insured";
    case "portfolio":
    case "financial_plan":
    case "retirement_plan":
      return "Account holder";
    // Realty rentals ride the sale families (2026-09-22,
    // shared/realty/rental.ts); the type says the person is a landlord
    // or a tenant. Literal slugs, not imports: this file stays
    // dependency-free (see header).
    case "listing":
      return serviceType === "rental_listing" ? "Landlord" : "Seller";
    case "home_purchase":
      return serviceType === "home_rental" ? "Tenant" : "Buyer";
    case "sale_transaction":
      return "Seller";
    default:
      return "Client";
  }
}
